import ApiHelper from 'api-helper';
import { TreatmentEpisode } from '@/models/treatment-episode';

export async function fetchTreatmentEpisodesApi(patientId: number | string): Promise<TreatmentEpisode[]> {
  const response = await ApiHelper.getApi('PatientTreatmentHistoryApi').getTreatmentEpisodes(patientId);
  return response.data || response || [];
}
